import React from "react";


const CustomSearchRender = ({ searchText, onSearch, clearSearch, fullWidth, backgroundColor }) => {
    return(
        <input 
            className="table-search-input"
            type="text" 
            value={searchText}  
            onChange={(event) => onSearch(event.target.value)} 
            placeholder="Search"
            style={{width: fullWidth ? '100%' : 'auto', backgroundColor: backgroundColor ?? "#fff"}}
        />
    )
}

export default CustomSearchRender